// utils/makeRemoteFile.js

export const makeRemoteFile = (fileObj, BeURL) => ({
    name:
        fileObj?.originalName ||
        fileObj?.storage?.path?.split("/").pop() ||
        "file",

    url: fileObj?.storage?.path
        ? `${BeURL}${fileObj.storage.path}`
        : null,

    isRemote: true,
    meta: fileObj || null,
});
